import { Warning } from "@mui/icons-material";
import { Alert, Box, Typography } from "@mui/joy";
import { ApiCompetition, ApiCompetitionDetail } from "griptonite-api-client";
import { useMemo } from "react";

import getPublishWarnings, { useHideWarningsMap } from "./getPublishWarnings";

const PublishWarningsAlert = ({
  tab,
  competition,
}: {
  tab: string;
  competition?: ApiCompetition | ApiCompetitionDetail;
}) => {
  const publishWarnings = useMemo(() => getPublishWarnings(competition), [competition]);

  const hideWarningsMap = useHideWarningsMap(competition?.uuid);

  return !hideWarningsMap[tab as keyof typeof hideWarningsMap] && publishWarnings.byTab[tab] ? (
    <Alert color="warning" sx={{ marginBottom: 1 }}>
      <Warning />
      <Box>
        <Typography level="title-sm">
          To publish your event, please fix the following issue
          {publishWarnings.byTab[tab].length > 1 ? "s" : ""}:
        </Typography>
        <ul style={{ margin: 0, fontWeight: "bold", paddingLeft: "1.5rem" }}>
          {publishWarnings.byTab[tab].map((warning, i) => (
            <li key={i}>{warning.message}</li>
          ))}
        </ul>
      </Box>
    </Alert>
  ) : null;
};

export default PublishWarningsAlert;
